module.exports = __webpack_public_path__ + "static/media/background-auth.6210d8bb.png";